<template>
  <UIDialog
    :is-open
    :z-index
    title="Contact Support"
    size="sm"
    @close="handleClose"
  >
    <p>Live chat is not available right now.</p>
    <p>
      Please reach out to us at
      <a href="mailto:support@allposit.com">support@allposit.com</a>
      and we'll get back to you shortly.
    </p>
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { UIDialog } from '@ui/modals'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const handleClose = () => {
  props.modal.close()
}
</script>

<style scoped>
a {
  @apply text-indigo-500 dark:text-indigo-400;
  @apply underline hover:no-underline;
}
</style>
